import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login-tries-modal',
  templateUrl: './login-tries-modal.component.html',
  styleUrls: ['./login-tries-modal.component.scss']
})
export class LoginTriesModalComponent {

  public title: string;
  public message: string;
  public emailLogin: string;
  public titleLoginMulti: string;

  constructor(
    public activeModal: NgbActiveModal
  ) {
    this.emailLogin = environment.emailLogin;
   }

}
